module.exports = __webpack_public_path__ + "img/男-缺血性心血管病h.91cc3f84.png";